import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import useSubscriptionIdentitySelect from './hooks/useSubscriptionIdentitySelect';
import Spinner from '../../../../../../../../../components/global/Spinner';
import IdentityContainer from './components/IdentityContainer';
import { getAlbumMembershipGroupIdentityByIdentityId } from '../../../../../Matches/components/PurchasingOptions/helpers';
import {
  getAlbumFolderSubscriptionCartItem,
  getAlbumSubscriptionCartItem,
} from '../../../../../../../../../services/checkout/redux/helpers';
import Button from '../../../../../../../../../components/global/Button';
import { getAsset } from '../../../../../../../../../util/assets';

const propTypes = {
  isAlbumSubscription: PropTypes.bool,
  hierarchyItemId: PropTypes.string,
  onIdentitySelect: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};

const SubscriptionIdentitySelect = ({
  isAlbumSubscription,
  hierarchyItemId,
  albumFolderId,
  albumId,
  onIdentitySelect,
  onClose,
}) => {
  const {
    albumMembershipGroup,
    identities,
    cart,
  } = useSubscriptionIdentitySelect({
    hierarchyItemId,
  });

  if (!identities || identities.length === 0) {
    return (
      <div className="w-100 h-100 d-flex align-items-center justify-content-center">
        <Spinner />
      </div>
    );
  }
  return (
    <Fragment>
      <div className="text-center mb-1">
        <img width={76} src={getAsset('/photopass.svg')} alt="" />
      </div>
      <h3 className="text-center">
        Who is this <span className="text-primary">Digital Photo Pass</span>{' '}
        for?
      </h3>
      <div className="subscription-identity-select-scroll">
        {identities.map(membershipIdentity => {
          const { identity } = membershipIdentity;

          const isPurchased =
            getAlbumMembershipGroupIdentityByIdentityId(
              albumMembershipGroup,
              identity.id,
            )?.has_purchased_subscription ?? false;

          const cartItem = isAlbumSubscription
            ? getAlbumSubscriptionCartItem(cart, {
                albumId,
                identityId: identity.id,
              })
            : getAlbumFolderSubscriptionCartItem(cart, {
                albumFolderId,
                identityId: identity.id,
              });

          return (
            <IdentityContainer
              identity={identity}
              onIdentitySelect={() => onIdentitySelect(identity)}
              cartItem={cartItem}
              isPurchased={isPurchased}
            />
          );
        })}
      </div>
      <div className="subscription-identity-select-sticky">
        <Button onClick={onClose}>Done</Button>
      </div>
    </Fragment>
  );
};

SubscriptionIdentitySelect.propTypes = propTypes;

export default SubscriptionIdentitySelect;
